import React, { useEffect, useState } from "react"
import { usePermission, useUserList } from "../../../../api/admin/user/hooks"
import ListTable from "../../../molecules/ListTable"
import styled from "styled-components"
import UserProfileSimple from "../../../molecules/UserProfileSimple"

//@@ 관리자가 본인 권한을 스스로 낮추었을 때 페이지 접근 및 기능 사용 권한 재설정 필요할지 (BE에서도 accessToken에서만 꺼내는게 아니라 DB 조회 필요)

const UserList = () => {
    const { data, isLoading, refetch } = useUserList()
    const userList = data?.data || []
    const { mutate: changeGrade, isLoading: gradeLoading } = usePermission()

    useEffect(() => {
        if (data) {
            console.log("@UserList", userList);
        }
    }, [data])

    const onGradeChange = (userIdx, newGrade) => {
		changeGrade(
			{ target_user_idx: userIdx, grade: newGrade },
			{
				onSuccess: () => {
					refetch()
				},
                onError: err => {
					console.error("권한 변경 실패:", err)
				}
			}
		)
	}

    const renderGrade = grade => {
        switch (grade) {
            case "2": return "최고"
            case "1": return "중간"
            case "0": return "일반"
            default: return "-"
        }
    }

    return (
        <>
            <h2>유저 목록</h2>

            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "80%" }}>Knotter</th>
                            <th style={{ width: "15%" }}>등급</th>
                        </tr>
                    </thead>

                    <tbody>
                        {userList && userList?.map((el, seq) => {
                                return (
                                    <tr key={seq}>
                                        <td className="seq">{seq + 1}</td>
                                        <td>
                                            <UserProfileSimple user={el} />
                                        </td>
                                        <td className="center">
                                            <GradeSelect
                                                value={el.grade}
                                                disabled={gradeLoading}
                                                onChange={e => onGradeChange(el.idx, e.target.value)}
                                                $grade={el.grade}
                                            >
                                                <option value="0">{renderGrade("0")}</option>
                                                <option value="1">{renderGrade("1")}</option>
                                                <option value="2">{renderGrade("2")}</option>
                                            </GradeSelect>
                                        </td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </ListTable>
            </div>
        </>
    )
}

export default UserList

const GradeSelect = styled.select`
	width: 90%;
    font-size: 16px;
	padding: 4px 8px;
	border: 1px solid var(--gray-color);
	border-radius: 4px;
    text-align: center
    text-align-last: center
    -moz-text-align-last: center
	color: var(--text-color);
	/* grade 값에 따라 background-color 설정 */
	background-color: ${props => {
        switch (props.$grade) {
            case "2": return "var(--highlight-dark-color)"
            case "1": return "var(--highlight-light-color)"
            default:  return "var(--base-light-color)"
        }
	}}
`